import * as React from "react";
import { DataGrid } from "@material-ui/data-grid";

const columns = [
  { field: "id", headerName: "ID", width: 70 },
  { field: "name", headerName: "Name", width: 200 },
  { field: "year", headerName: "Year", width: 130 },
  { field: "description", headerName: "Description", width: 300 },
  { field: "size", headerName: "Size", width: 130 },

  { field: "origin", headerName: "Origin", width: 150 },
];

const rows = [
  {
    id: 1,
    name: "Metaplastic Breast Cancer",
    year: "2021",
    description: "Targeted or whole-exome sequencing",
    size: "19 samples",
    origin: "MSK",
  },
  {
    id: 2,
    name: "Breast Invasive Carcinoma",
    year: "2012",
    description: "Whole genome/exome sequencing",
    size: "65 samples",
    origin: "British Columbia",
  },
  {
    id: 3,
    name: "Breast Invasive Carcinoma",
    year: "2012",
    description: "Whole-exome sequencing",
    size: "103 samples",
    origin: "Broad Institute",
  },
  {
    id: 4,
    name: "Breast Invasive Carcinoma",
    year: "2012",
    description: "Whole-exome sequencing",
    size: "100 samples",
    origin: "Sanger",
  },
  {
    id: 5,
    name: "Breast Cancer",
    year: "2016",
    description: "Targeted sequencing of tumors",
    size: "1904 samples",
    origin: "Nat Commun",
  },
  {
    id: 6,
    name: "The Metastatic Breast Cancer Project",
    year: "2020",
    description: "Primary and/or metastatic tumor specimens",
    size: "237 samples",
    origin: "Provisional",
  },
  {
    id: 7,
    name: "Metastatic Breast Cancer",
    year: "2016",
    description: "Whole exome sequencing",
    size: "216 samples",
    origin: "INCERM",
  },
];

export default function DataTable(props) {
  return (
    <div style={{ height: 450, width: "88%", marginLeft: "3%" }}>
      <DataGrid
        rows={rows}
        columns={columns}
        pageSize={5}
        checkboxSelection
        onRowSelected={(e) => {
          props.onRowSelected(e);
        }}
      />
    </div>
  );
}
